import React from "react";
import { FontAwesome } from "@expo/vector-icons";
import { Send } from "react-native-gifted-chat";

const SendButton = (props) => {
  return (
    <Send
      {...props}
      containerStyle={{
        justifyContent: 'center',
        alignItems: 'center',
        paddingRight: 10,
        paddingLeft: 10
      }}
    >
      <FontAwesome name="send" size={24} color="#fff" />
    </Send>
  );
};

export default SendButton;